(() => {
  const $ = (selector, context = document) => context.querySelector(selector);
  const $$ = (selector, context = document) => [...context.querySelectorAll(selector)];
  const wishlistStorageKey = 'mythcove-wishlist';

  let activeDrawer = null;
  let activeDrawerTrigger = null;
  let storeConfig;
  let wishlistItems = [];

  const escapeHTML = (value = '') => String(value).replace(/[&<>"']/g, (character) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#039;'
  })[character]);

  const getStoreConfig = () => {
    if (storeConfig) return storeConfig;
    try {
      storeConfig = JSON.parse($('#MythCoveStoreConfig')?.textContent || '{}');
    } catch (_) {
      storeConfig = {};
    }
    return storeConfig;
  };

  const formatMoney = (cents, currency) => {
    const activeCurrency = currency || getStoreConfig().currency || window.Shopify?.currency?.active || 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: activeCurrency
      }).format(Number(cents || 0) / 100);
    } catch (_) {
      return '$' + (Number(cents || 0) / 100).toFixed(2);
    }
  };

  const closeWorldsMenus = () => {
    $$('[data-worlds-dropdown]').forEach((dropdown) => {
      const toggle = $('[data-worlds-toggle]', dropdown);
      const menu = $('[data-worlds-menu]', dropdown);
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      if (menu) menu.hidden = true;
    });
  };

  const initHeader = () => {
    const toggle = $('[data-menu-toggle]');
    const navigation = $('[data-mobile-navigation]');

    if (toggle && navigation && toggle.dataset.ready !== 'true') {
      toggle.dataset.ready = 'true';
      toggle.addEventListener('click', () => {
        const open = toggle.getAttribute('aria-expanded') !== 'true';
        toggle.setAttribute('aria-expanded', String(open));
        navigation.hidden = !open;
        document.body.classList.toggle('menu-open', open);
        if (open) closeWorldsMenus();
      });
    }

    $$('[data-worlds-dropdown]').forEach((dropdown) => {
      const worldsToggle = $('[data-worlds-toggle]', dropdown);
      const menu = $('[data-worlds-menu]', dropdown);
      if (!worldsToggle || !menu || worldsToggle.dataset.ready === 'true') return;
      worldsToggle.dataset.ready = 'true';
      worldsToggle.addEventListener('click', (event) => {
        event.stopPropagation();
        const open = worldsToggle.getAttribute('aria-expanded') !== 'true';
        closeWorldsMenus();
        worldsToggle.setAttribute('aria-expanded', String(open));
        menu.hidden = !open;
      });
    });

    if (document.documentElement.dataset.worldsReady !== 'true') {
      document.documentElement.dataset.worldsReady = 'true';
      document.addEventListener('click', (event) => {
        if (!event.target.closest('[data-worlds-dropdown]')) closeWorldsMenus();
      });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') closeWorldsMenus();
      });
    }
  };

  const openDrawer = (drawer, trigger) => {
    if (!drawer) return;
    if (activeDrawer && activeDrawer !== drawer) {
      activeDrawer.classList.remove('is-open');
      activeDrawer.hidden = true;
      activeDrawer.setAttribute('aria-hidden', 'true');
    }

    const overlay = $('[data-drawer-overlay]');
    activeDrawer = drawer;
    activeDrawerTrigger = trigger || document.activeElement;
    drawer.hidden = false;
    drawer.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.hidden = false;
    document.body.classList.add('drawer-open');

    window.requestAnimationFrame(() => {
      drawer.classList.add('is-open');
      overlay?.classList.add('is-open');
      $('[data-drawer-close]', drawer)?.focus();
    });
  };

  const closeDrawer = () => {
    if (!activeDrawer) return;
    const drawer = activeDrawer;
    const overlay = $('[data-drawer-overlay]');
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    overlay?.classList.remove('is-open');
    document.body.classList.remove('drawer-open');
    activeDrawer = null;

    window.setTimeout(() => {
      if (!drawer.classList.contains('is-open')) drawer.hidden = true;
      if (!activeDrawer && overlay) overlay.hidden = true;
    }, 220);

    if (activeDrawerTrigger instanceof HTMLElement) activeDrawerTrigger.focus();
    activeDrawerTrigger = null;
  };

  const updateCartCount = (count) => {
    $$('[data-cart-count]').forEach((badge) => {
      badge.textContent = count > 99 ? '99+' : String(count);
      badge.hidden = count < 1;
    });
    $$('[data-cart-open]').forEach((trigger) => {
      trigger.setAttribute('aria-label', 'Cart, ' + count + ' item' + (count === 1 ? '' : 's'));
    });
  };

  const renderCart = (cart) => {
    const body = $('[data-cart-drawer-body]');
    const footer = $('[data-cart-drawer-footer]');
    if (!body || !footer) return;

    updateCartCount(Number(cart.item_count || 0));
    if (!cart.items?.length) {
      body.innerHTML = '<div class="mc-drawer__empty"><p>Your cart is waiting for its first discovery.</p><a class="mc-text-link" href="' + escapeHTML(getStoreConfig().allProductsUrl || '/collections/all') + '">Explore the Cove</a></div>';
      footer.hidden = true;
      return;
    }

    body.innerHTML = cart.items.map((item) => {
      const image = item.image
        ? '<a class="mc-drawer-item__image" href="' + escapeHTML(item.url) + '"><img src="' + escapeHTML(item.image) + '" alt="" width="160" height="200"></a>'
        : '<a class="mc-drawer-item__image mc-drawer-item__image--empty" href="' + escapeHTML(item.url) + '"></a>';
      const variant = item.variant_title && item.variant_title !== 'Default Title'
        ? '<p class="mc-drawer-item__variant">' + escapeHTML(item.variant_title) + '</p>'
        : '';
      return '<article class="mc-drawer-item" data-cart-line data-line-key="' + escapeHTML(item.key) + '" data-quantity="' + Number(item.quantity) + '">' +
        image +
        '<div class="mc-drawer-item__content">' +
          '<p class="mc-drawer-item__vendor">' + escapeHTML(item.vendor || '') + '</p>' +
          '<h3><a href="' + escapeHTML(item.url) + '">' + escapeHTML(item.product_title) + '</a></h3>' +
          variant +
          '<p class="mc-drawer-item__price">' + formatMoney(item.final_line_price, cart.currency) + '</p>' +
          '<div class="mc-drawer-item__actions">' +
            '<div class="mc-drawer-quantity">' +
              '<button type="button" aria-label="Decrease quantity" data-cart-quantity="-1">−</button>' +
              '<span aria-label="Quantity">' + Number(item.quantity) + '</span>' +
              '<button type="button" aria-label="Increase quantity" data-cart-quantity="1">+</button>' +
            '</div>' +
            '<button class="mc-drawer-item__remove" type="button" data-cart-remove>Remove</button>' +
          '</div>' +
        '</div>' +
      '</article>';
    }).join('');

    const subtotal = $('[data-cart-subtotal]');
    if (subtotal) subtotal.textContent = formatMoney(cart.total_price, cart.currency);
    footer.hidden = false;
  };

  const fetchCart = async () => {
    const response = await fetch(getStoreConfig().cartJsonUrl || '/cart.js', {
      headers: { Accept: 'application/json' }
    });
    if (!response.ok) throw new Error('Unable to load the cart.');
    return response.json();
  };

  const refreshCart = async () => {
    const cart = await fetchCart();
    renderCart(cart);
    return cart;
  };

  const addVariantToCart = async (variantId, quantity = 1) => {
    const response = await fetch(getStoreConfig().cartAddUrl || '/cart/add.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: Number(quantity) }] })
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || 'This item could not be added to the cart.');
    return data;
  };

  const changeCartLine = async (key, quantity) => {
    const response = await fetch(getStoreConfig().cartChangeUrl || '/cart/change.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ id: key, quantity: Number(quantity) })
    });
    const cart = await response.json();
    if (!response.ok) throw new Error(cart.description || 'The cart could not be updated.');
    renderCart(cart);
    return cart;
  };

  const readWishlist = () => {
    try {
      const saved = JSON.parse(localStorage.getItem(wishlistStorageKey) || '[]');
      if (!Array.isArray(saved)) return [];
      return saved.map((item) => typeof item === 'string' ? { key: item } : item).filter((item) => item?.key);
    } catch (_) {
      return [];
    }
  };

  const saveWishlist = () => {
    try {
      localStorage.setItem(wishlistStorageKey, JSON.stringify(wishlistItems));
    } catch (_) {
      // Private browsing or strict storage settings can block localStorage.
    }
  };

  const wishlistItemFromButton = (button) => ({
    key: button.dataset.wishlistKey,
    title: button.dataset.wishlistTitle || button.dataset.wishlistKey,
    url: button.dataset.wishlistUrl || '/products/' + button.dataset.wishlistKey,
    image: button.dataset.wishlistImage || '',
    price: button.dataset.wishlistPrice || '',
    variantId: button.dataset.wishlistVariantId || '',
    available: button.dataset.wishlistAvailable === 'true'
  });

  const updateWishlistState = () => {
    const savedKeys = wishlistItems.map((item) => item.key);
    $$('[data-wishlist-button]').forEach((button) => {
      const active = savedKeys.includes(button.dataset.wishlistKey);
      button.setAttribute('aria-pressed', String(active));
      button.setAttribute('aria-label', (active ? 'Remove ' : 'Add ') + (button.dataset.wishlistTitle || 'item') + (active ? ' from wishlist' : ' to wishlist'));
    });

    $$('[data-header-wishlist]').forEach((button) => {
      const count = wishlistItems.length;
      button.setAttribute('aria-pressed', String(count > 0));
      button.setAttribute('aria-label', 'Wishlist' + (count ? ', ' + count + ' saved' : ''));
    });

    $$('[data-wishlist-count]').forEach((badge) => {
      badge.textContent = wishlistItems.length > 99 ? '99+' : String(wishlistItems.length);
      badge.hidden = wishlistItems.length < 1;
    });
  };

  const renderWishlist = () => {
    const body = $('[data-wishlist-drawer-body]');
    if (!body) return;
    if (!wishlistItems.length) {
      body.innerHTML = '<div class="mc-drawer__empty"><p>Save the objects that make your world feel more like yours.</p></div>';
      return;
    }

    body.innerHTML = wishlistItems.map((item) => {
      const image = item.image
        ? '<a class="mc-drawer-item__image" href="' + escapeHTML(item.url) + '"><img src="' + escapeHTML(item.image) + '" alt="" width="160" height="200"></a>'
        : '<a class="mc-drawer-item__image mc-drawer-item__image--empty" href="' + escapeHTML(item.url) + '"></a>';
      const addButton = item.variantId && item.available
        ? '<button class="mc-drawer-item__add" type="button" data-wishlist-add data-variant-id="' + escapeHTML(item.variantId) + '">Add to Cart</button>'
        : '<a class="mc-drawer-item__add" href="' + escapeHTML(item.url) + '">View item</a>';
      return '<article class="mc-drawer-item" data-wishlist-line data-wishlist-key="' + escapeHTML(item.key) + '">' +
        image +
        '<div class="mc-drawer-item__content">' +
          '<h3><a href="' + escapeHTML(item.url) + '">' + escapeHTML(item.title || item.key) + '</a></h3>' +
          (item.price ? '<p class="mc-drawer-item__price">' + escapeHTML(item.price) + '</p>' : '') +
          '<div class="mc-drawer-item__actions">' +
            addButton +
            '<button class="mc-drawer-item__remove" type="button" data-wishlist-remove>Remove</button>' +
          '</div>' +
        '</div>' +
      '</article>';
    }).join('');
  };

  const toggleWishlistItem = (item) => {
    const exists = wishlistItems.some((saved) => saved.key === item.key);
    wishlistItems = exists
      ? wishlistItems.filter((saved) => saved.key !== item.key)
      : [...wishlistItems, item];
    saveWishlist();
    updateWishlistState();
    renderWishlist();
  };

  const initCreatorTabs = (root = document) => {
    $$('[data-creator-picks]', root).forEach((section) => {
      const tabs = $$('[data-creator-tab]', section);
      const panels = $$('[data-creator-panel]', section);
      tabs.forEach((tab, index) => {
        if (tab.dataset.ready === 'true') return;
        tab.dataset.ready = 'true';
        tab.addEventListener('click', () => {
          tabs.forEach((item) => item.setAttribute('aria-selected', 'false'));
          panels.forEach((panel) => { panel.hidden = true; });
          tab.setAttribute('aria-selected', 'true');
          if (panels[index]) panels[index].hidden = false;
        });
      });
    });
  };

  const initProductMedia = (root = document) => {
    $$('[data-product-media]', root).forEach((gallery) => {
      const thumbs = $$('[data-media-thumb]', gallery);
      const items = $$('[data-media-id]', gallery);
      const activate = (id) => {
        thumbs.forEach((thumb) => thumb.setAttribute('aria-selected', String(thumb.dataset.mediaThumb === id)));
        items.forEach((item) => {
          const active = item.dataset.mediaId === id;
          item.hidden = !active;
          item.classList.toggle('is-active', active);
        });
      };
      thumbs.forEach((thumb) => {
        if (thumb.dataset.ready === 'true') return;
        thumb.dataset.ready = 'true';
        thumb.addEventListener('click', () => activate(thumb.dataset.mediaThumb));
      });
      gallery.activateMedia = activate;
    });
  };

  const initProductForms = (root = document) => {
    $$('[data-product-root]', root).forEach((productRoot) => {
      const variantsNode = $('[data-product-variants]', productRoot);
      const form = $('[data-product-form]', productRoot);
      if (!variantsNode || !form) return;

      const variants = JSON.parse(variantsNode.textContent);
      const optionGroups = $$('.variant-option', form);
      const variantSelect = $('[data-variant-select]', form);
      const addButton = $('[data-add-to-cart]', form);
      const addText = $('[data-add-text]', form);
      const price = $('[data-product-price]', productRoot);
      const stickyButton = $('[data-sticky-add]', productRoot);
      const stickyText = $('[data-sticky-add-text]', productRoot);
      const stickyPrice = $('[data-sticky-price]', productRoot);
      const wishlistButton = $('[data-wishlist-button]', form);

      const updateVariant = () => {
        const selected = optionGroups.map((group) => $('[data-option-value]:checked', group)?.value);
        optionGroups.forEach((group) => {
          const label = $('[data-selected-option]', group);
          const value = $('[data-option-value]:checked', group)?.value;
          if (label) label.textContent = value || '';
        });
        const variant = variants.find((item) => item.options.every((option, index) => option === selected[index]));
        if (!variant) {
          addButton.disabled = true;
          addText.textContent = 'Combination unavailable';
          if (stickyButton) stickyButton.disabled = true;
          if (stickyText) stickyText.textContent = 'Combination unavailable';
          return;
        }

        const formattedPrice = formatMoney(variant.price);
        variantSelect.value = String(variant.id);
        addButton.disabled = !variant.available;
        addText.textContent = variant.available ? 'Add to Cart' : 'Unavailable in this realm';
        if (price) price.textContent = formattedPrice;
        if (stickyButton) stickyButton.disabled = !variant.available;
        if (stickyText) stickyText.textContent = variant.available ? 'Add to Cart' : 'Unavailable';
        if (stickyPrice) stickyPrice.textContent = formattedPrice;
        if (wishlistButton) {
          wishlistButton.dataset.wishlistVariantId = String(variant.id);
          wishlistButton.dataset.wishlistPrice = formattedPrice;
          wishlistButton.dataset.wishlistAvailable = String(variant.available);
        }
        if (variant.featured_media) {
          $('[data-product-media]', productRoot)?.activateMedia(String(variant.featured_media.id));
        }
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      };

      $$('[data-option-value]', form).forEach((option) => {
        if (option.dataset.ready === 'true') return;
        option.dataset.ready = 'true';
        option.addEventListener('change', updateVariant);
      });

      if (stickyButton && stickyButton.dataset.ready !== 'true') {
        stickyButton.dataset.ready = 'true';
        stickyButton.addEventListener('click', () => form.requestSubmit(addButton));
      }

      if (form.dataset.ajaxReady !== 'true') {
        form.dataset.ajaxReady = 'true';
        form.addEventListener('submit', async (event) => {
          event.preventDefault();
          const errorNode = $('[data-form-error]', form);
          const originalText = addText.textContent;
          addButton.disabled = true;
          addText.textContent = 'Adding…';
          if (stickyButton) stickyButton.disabled = true;
          if (stickyText) stickyText.textContent = 'Adding…';
          if (errorNode) errorNode.hidden = true;

          try {
            const response = await fetch(getStoreConfig().cartAddUrl || '/cart/add.js', {
              method: 'POST',
              headers: {
                Accept: 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
              },
              body: new FormData(form)
            });
            const data = await response.json();
            if (!response.ok) throw new Error(data.description || 'This item could not be added to the cart.');
            const cart = await refreshCart();
            addText.textContent = 'Added ✓';
            if (stickyText) stickyText.textContent = 'Added ✓';
            openDrawer($('[data-cart-drawer]'), addButton);
            window.setTimeout(() => {
              addText.textContent = originalText;
              addButton.disabled = !variants.find((variant) => String(variant.id) === variantSelect.value)?.available;
              if (stickyText) stickyText.textContent = originalText;
              if (stickyButton) stickyButton.disabled = addButton.disabled;
            }, 1400);
            updateCartCount(cart.item_count);
          } catch (error) {
            if (errorNode) {
              errorNode.textContent = error.message;
              errorNode.hidden = false;
            }
            addText.textContent = originalText;
            addButton.disabled = false;
            if (stickyText) stickyText.textContent = originalText;
            if (stickyButton) stickyButton.disabled = false;
          }
        });
      }
    });
  };

  const initRecommendations = (root = document) => {
    $$('[data-product-recommendations]', root).forEach((section) => {
      if (section.dataset.loaded === 'true' || !section.dataset.url) return;
      section.dataset.loaded = 'true';
      fetch(section.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const parsed = new DOMParser().parseFromString(text, 'text/html');
          const replacement = $('[data-product-recommendations]', parsed);
          if (replacement?.innerHTML.trim()) {
            section.innerHTML = replacement.innerHTML;
            init(section);
          }
        })
        .catch(() => { section.dataset.loaded = 'false'; });
    });
  };

  const initSort = (root = document) => {
    $$('[data-sort-by]', root).forEach((select) => {
      if (select.dataset.ready === 'true') return;
      select.dataset.ready = 'true';
      select.addEventListener('change', () => {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', select.value);
        window.location.assign(url.toString());
      });
    });
  };

  const initCursor = () => {
    const glow = $('[data-cursor-glow]');
    if (!glow || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    window.addEventListener('pointermove', (event) => {
      glow.style.left = event.clientX + 'px';
      glow.style.top = event.clientY + 'px';
    }, { passive: true });
  };

  const initWishlists = (root = document) => {
    let metadataChanged = false;
    $$('[data-wishlist-button]', root).forEach((button) => {
      const item = wishlistItemFromButton(button);
      const savedIndex = wishlistItems.findIndex((saved) => saved.key === item.key);
      if (savedIndex >= 0 && (!wishlistItems[savedIndex].title || !wishlistItems[savedIndex].variantId) && item.title) {
        wishlistItems[savedIndex] = { ...wishlistItems[savedIndex], ...item };
        metadataChanged = true;
      }
      if (button.dataset.ready === 'true') return;
      button.dataset.ready = 'true';
      button.addEventListener('click', () => toggleWishlistItem(wishlistItemFromButton(button)));
    });
    if (metadataChanged) saveWishlist();
    updateWishlistState();
    renderWishlist();
  };

  const initStoreDrawers = () => {
    const overlay = $('[data-drawer-overlay]');
    if (overlay && overlay.dataset.ready !== 'true') {
      overlay.dataset.ready = 'true';
      overlay.addEventListener('click', closeDrawer);
    }

    $$('[data-drawer-close]').forEach((button) => {
      if (button.dataset.ready === 'true') return;
      button.dataset.ready = 'true';
      button.addEventListener('click', closeDrawer);
    });

    $$('[data-cart-open]').forEach((trigger) => {
      if (trigger.dataset.ready === 'true') return;
      trigger.dataset.ready = 'true';
      trigger.addEventListener('click', async (event) => {
        event.preventDefault();
        const body = $('[data-cart-drawer-body]');
        if (body) body.innerHTML = '<p class="mc-drawer__loading">Loading your cart…</p>';
        openDrawer($('[data-cart-drawer]'), trigger);
        try {
          await refreshCart();
        } catch (_) {
          window.location.assign(trigger.href);
        }
      });
    });

    $$('[data-header-wishlist]').forEach((trigger) => {
      if (trigger.dataset.ready === 'true') return;
      trigger.dataset.ready = 'true';
      trigger.addEventListener('click', () => {
        renderWishlist();
        openDrawer($('[data-wishlist-drawer]'), trigger);
      });
    });

    const cartDrawer = $('[data-cart-drawer]');
    if (cartDrawer && cartDrawer.dataset.ready !== 'true') {
      cartDrawer.dataset.ready = 'true';
      cartDrawer.addEventListener('click', async (event) => {
        const line = event.target.closest('[data-cart-line]');
        if (!line) return;
        const key = line.dataset.lineKey;
        if (event.target.closest('[data-cart-remove]')) {
          await changeCartLine(key, 0);
          return;
        }
        const quantityButton = event.target.closest('[data-cart-quantity]');
        if (quantityButton) {
          const quantity = Math.max(0, Number(line.dataset.quantity) + Number(quantityButton.dataset.cartQuantity));
          await changeCartLine(key, quantity);
        }
      });
    }

    const wishlistDrawer = $('[data-wishlist-drawer]');
    if (wishlistDrawer && wishlistDrawer.dataset.ready !== 'true') {
      wishlistDrawer.dataset.ready = 'true';
      wishlistDrawer.addEventListener('click', async (event) => {
        const line = event.target.closest('[data-wishlist-line]');
        if (!line) return;
        const key = line.dataset.wishlistKey;
        if (event.target.closest('[data-wishlist-remove]')) {
          wishlistItems = wishlistItems.filter((item) => item.key !== key);
          saveWishlist();
          updateWishlistState();
          renderWishlist();
          return;
        }
        const addButton = event.target.closest('[data-wishlist-add]');
        if (addButton) {
          addButton.disabled = true;
          addButton.textContent = 'Adding…';
          try {
            await addVariantToCart(addButton.dataset.variantId);
            await refreshCart();
            closeDrawer();
            openDrawer($('[data-cart-drawer]'), $('[data-header-wishlist]'));
          } catch (error) {
            addButton.disabled = false;
            addButton.textContent = error.message;
          }
        }
      });
    }

    if (document.documentElement.dataset.drawerReady !== 'true') {
      document.documentElement.dataset.drawerReady = 'true';
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && activeDrawer) closeDrawer();
      });
    }
  };

  const initNewsletterInterests = (root = document) => {
    $$('[data-interest-form]', root).forEach((form) => {
      if (form.dataset.ready === 'true') return;
      form.dataset.ready = 'true';
      const tagsInput = $('[data-interest-tags]', form);
      const buttons = $$('[data-interest-button]', form);
      const updateTags = () => {
        const interests = buttons
          .filter((button) => button.getAttribute('aria-pressed') === 'true')
          .map((button) => button.dataset.interest);
        if (tagsInput) tagsInput.value = ['newsletter', 'mythcove', ...interests].join(',');
      };
      buttons.forEach((button) => button.addEventListener('click', () => {
        button.setAttribute('aria-pressed', String(button.getAttribute('aria-pressed') !== 'true'));
        updateTags();
      }));
    });
  };

  const initQuantitySelectors = (root = document) => {
    $$('[data-quantity-selector]', root).forEach((selector) => {
      if (selector.dataset.ready === 'true') return;
      selector.dataset.ready = 'true';
      const input = $('[data-quantity-input]', selector);
      const minus = $('[data-quantity-minus]', selector);
      const plus = $('[data-quantity-plus]', selector);
      if (!input) return;
      const changeBy = (amount) => {
        const minimum = Number(input.min || 1);
        const current = Number(input.value || minimum);
        input.value = String(Math.max(minimum, current + amount));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      };
      minus?.addEventListener('click', () => changeBy(-1));
      plus?.addEventListener('click', () => changeBy(1));
    });
  };

  const init = (root = document) => {
    initCreatorTabs(root);
    initProductMedia(root);
    initProductForms(root);
    initRecommendations(root);
    initSort(root);
    initWishlists(root);
    initNewsletterInterests(root);
    initQuantitySelectors(root);
  };

  document.addEventListener('DOMContentLoaded', () => {
    wishlistItems = readWishlist();
    initHeader();
    initStoreDrawers();
    init();
    initCursor();
  });
  document.addEventListener('shopify:section:load', (event) => {
    initHeader();
    initStoreDrawers();
    init(event.target);
  });
})();
